// extracted by mini-css-extract-plugin
export default {"tab":"tabs_tab__TUjaE","active":"tabs_active__SQQAg","tabcontent":"tabs_tabcontent__8q-k2"};